//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getUserInfo, isApp,} from '@/util/const'
import {setAuthorization} from '@/axios/userInfo'
import moment from 'moment'

export default {
    name: "couponDetail",
    data() {
        return {
            lang: '',
            useCondition: '',
            useMethod: '',
            snapshotId: '',
            offerCode: '',
            //0：动态  1：静态  2：通用码
            offerCodeType: '',
            // （1：待使用 2：已使用 3：已过期）
            status: '',
            statusName: '',
            remainDay: '',
            startUseTime: '',
            endUseTime: '',
            // 0：eshop专享  1：门店专享
            usePoint: '',
            usePointName: '',
            couponName: '',
            icon: '',
            url: '',
        }
    },
    methods: {
        // 时间转换
        timeChange(time) {
            time = time.replace('T', ' ')
            time = time.substring(0, 10)
            time = time.replace(/\-/g, '/')
            return time
        },
        // 语言格式转换
        langFormat(str) {
            str = JSON.parse(str)
            if (this.lang === 'sc') {
                return str.zh_cn
            } else if (this.lang === 'tc') {
                return str.zh_tw
            } else {
                return str.en_us
            }
        },
        // 复制
        CopyUrl() {
            this.$copyText(this.offerCode).then(e => {
                this.$toast({msg: this.$t('everyDaySpecial.detail.t13')})
            }, function (e) {
                this.$toast({msg: this.$t('everyDaySpecial.detail.t14')})
            })
        },
        // 跳转核销
        jump() {
            if(this.usePoint === 0){
                window.location.href = this.url
            }else if(this.usePoint === 1){
                this.$router.push({
                    path: '/everyDaySpecial/couponDestruction',
                    query: {
                        offerCode: this.offerCode,
                        snapshotId: this.snapshotId,
                        couponName: this.couponName,
                        icon: this.icon,
                    },
                })
            }
        }
    },
    created() {
        if (!isApp()) this.isApp = false
        window.getUserInfo = (obj) => {
            if (obj) {
                setAuthorization(obj.authorization)
            }
            if (!isApp() || system() === 'unknown') {

            } else {
                getUserInfo({callbackName: 'getUserInfo', needLogin: false})
            }
        }
        this.lang = window.localStorage.lang
        let snapshotId = this.$route.query.id
        this.$http.getOther(`/dayDiscount/coupon/couponSnapshot/${snapshotId}`).then(res => {
            if (res.data.code === 10000) {
                let data = res.data.data
                this.useCondition = this.langFormat(data.useCondition)
                this.useMethod = this.langFormat(data.useMethod)
                this.couponName = this.langFormat(data.couponName)
                this.icon = this.langFormat(data.icon)
                this.snapshotId = data.snapshotId
                this.offerCode = data.offerCode
                this.offerCodeType = data.offerCodeType
                this.status = data.status
                this.statusName = data.status === 1 ? this.$t('everyDaySpecial.detail.t6-1') : (data.status === 2 ? this.$t('everyDaySpecial.detail.t6-2') : this.$t('everyDaySpecial.detail.t6-3'))
                this.remainDay = data.remainDay
                this.startUseTime = this.timeChange(data.startUseTime)
                this.endUseTime = this.timeChange(data.endUseTime)
                this.usePointName = data.usePoint === 0 ? this.$t('everyDaySpecial.detail.t1') : this.$t('everyDaySpecial.detail.t2')
                this.usePoint = data.usePoint
                this.url = this.langFormat(data.url)
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/page/everyDaySpecial/couponDetail.vue